<template><div><h1>VUX 是否为微信团队项目</h1>
<p>否。但是依赖的WeUI是微信团队的开源项目，感谢微信团队。</p>
</div></template><script>
export default {
  head: {"title":"VUX 是否为微信团队项目 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// is-vux-wechat-official-project-46.vue?d95ae4ea